<template>
  <div :class="`upload-file-content ${!inPage ? 'twoCols' : ''}`">
    <div v-if="!inPage" class="upload-content-left">
      <span><i style="color: #FF5964; vertical-align: middle">*</i> 选择文件</span>
    </div>

    <div class="upload-content-right">
      <el-upload
        ref="ref_uploader"
        action="/upload"
        class="el-upload"
        v-bind="$attrs"
        v-on="$listeners"
        :accept="accept"
        :maxSize="maxSize"
        :maxCount="maxCount"
        :auto-upload="true"
        :show-file-list="false"
        :file-list="fileList"
        :http-request="uploadRequest"
        :before-upload="handleBeforeUpload"
        :on-change="handleChange"
        :on-success="handleSuccess"
        :on-remove="handleRemove"
        :on-error="handleError"
      >
        <el-button v-if="!disabled" icon="BLM-icon-export" type="primary">选择文件</el-button>
        <div v-else class="btn-disabled inline-block" @click.stop>
          <el-button :disabled="disabled" icon="BLM-icon-export" type="primary">选择文件</el-button>
        </div>

        <!-- 模版下载 -->
        <div @click.stop class="template-box inline-block">
          <template v-if="!isMultiTemplate">
            <a v-if="!disabled" @click.stop="checkHref(templateUrl)" :href="templateUrl">
              <el-button icon="BLM-icon-import" @click.stop type="text">下载导入模版</el-button>
            </a>
            <div v-else>
              <el-button icon="BLM-icon-import" @click.stop type="text">下载导入模版</el-button>
            </div>
          </template>
          <el-button v-else icon="BLM-icon-import" type="text" @click.stop="showTemplateDialog">下载导入模版</el-button>
        </div>

        <!-- 历史记录查询 -->
        <div v-if="$slots.history" @click.stop class="history-slot-box inline-block">
          <slot name="history"></slot>
        </div>
        <slot name="supplement"></slot>
        <!-- 上传辅助文案 支持自定义 -->
        <div slot="tip" class="el-upload__tip" style="color: #606266;">
          <span>仅可上传{{ acceptArr.join('/') }}文件格式</span>
          <span v-if="fileMaxSize">，文件尺寸≤{{ fileMaxSize }}</span>
          <span v-if="maxCount">，数据数量≤{{ maxCount }}条</span><br/>
          <slot v-if="$slots.hint" name="hint"></slot>
        </div>
      </el-upload>

      <div class="border-box file-list" v-if="fileList.length > 0" v-loading="loading">
        <div v-for="(file, index) in fileList" :key="index">
          <div class="file-list-item flex justify-between">
            <!-- 文件名 -->
            <el-tooltip :content="file.name" :disabled="tipShow" :open-delay="150" popper-class="public-import-tooltip-popper" placement="bottom-end" effect="dark">
              <span class="text-span icon-left file-item-filename" @mouseover="handleFilenameMouseOver($event)" style="cursor: default;"><i class="el-icon-document"/>{{ file.name }}</span>
            </el-tooltip>
            <!-- 进度 状态 操作 -->
            <span class="text-span icon-right" v-if="file.status === 'uploading'" type="text" @click="handleRemove(file)">{{ file.percentage }}%<i class="BLM-icon-loading"/></span>
            <div v-else>
              <i v-if="file.status === 'success' || file.status === 'fail'" :class="file.status === 'success' ? 'icon-upload-success BLM-icon-success' : 'icon-upload-fail BLM-icon-error'"/>
              <el-button type="text" :disabled="deleteDisable" @click="handleRemove(file)">删除</el-button>
            </div>
          </div>
          <!-- 进度条 -->
          <el-progress :show-text="false" :stroke-width="2" :percentage="file.percentage"/>
        </div>
      </div>

      <!-- 一步式导入 - 操作栏 -->
      <div v-if="!inPage" class="dialog-footer">
        <el-button :disabled="fileList.length < 1" type="primary" @click="toNextStep">确 定</el-button>
        <el-button @click="handleDialogClose">取 消</el-button>
      </div>

      <!-- 多模版下载弹框 -->
      <el-dialog
        v-if="isMultiTemplate"
        title="导入模板下载"
        :visible.sync="templateDialogVisible"
        :close-on-click-modal="false"
        destroy-on-close
        width="400px"
      >
        <a class="template-url-box" v-for="(item, index) of templateUrl" @click.stop="checkHref(item.href)" :href="item.href" :key="index">
          <el-button :disabled="disabled" icon="BLM-icon-import" type="text">{{ item.templateName }}</el-button>
        </a>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { uploadFileNotShared } from './upload-mixin'
import { ref, watch, computed } from 'vue'
import { Message } from 'element-ui'
// 文件尺寸单位
const unitsOfSize = ['B', 'KB', 'MB', 'GB', 'TB']
// 定时器时间
const timerGap = 150

const props = defineProps({
  value: {
    type: Array,
    default: () => [],
  },
  // 内容是否嵌入页面true / 弹框展示false
  inPage: {
    type: Boolean,
    default: true,
  },
  // 模版文件地址
  templateUrl: {
    type: [String, Array],
    default: '#',
  },
  // 是否禁用
  disabled: {
    type: Boolean,
    default: false,
  },
  // 支持的文件类型
  accept: {
    type: String,
    default: '.xlsx',
  },
  // 文件最大大小/尺寸, 单位/Byte, eq. 1024=1KB, 1024*1024=1MB, 1024*1024*1024=1GB, 1024*1024*1024*1024=1TB
  maxSize: {
    type: Number,
    default: 1024 * 1024 * 10,
  },
  // 数据最大条数, 单位/条
  maxCount: {
    type: Number,
  },
  // true 使用私有上传接口 false 公有
  // privateMode: {
  //   type: Boolean,
  //   default: false,
  // },
  // 自定义上传前钩子
  onBeforeUpload: Function,
  shardUpload: {
    type: Boolean,
    default: true,
  },
  group: {
    type: String,
    default: 'assert',
  },
  code: {
    type: String,
    default: 'assert_import_file',
  },
  uploadType: {
    type: String,
    default: '',
  },
  taskId: {
    type: String,
    default: '',
  },
  taskStatus: {
    type: [Number, String],
    default: 0,
  },
})

const loading = ref(false)
// 文件列表
const fileList = ref([])
// 是否展示多模版下载弹框
const templateDialogVisible = ref(false)
// 控制tooltip展示
const tipShow = ref(false)
const ref_uploader = ref(null)

const chunkSize = 0
// 删除按钮是否disable
const deleteDisable = ref(false)
watch(() => props.value, (val) => {
  val.forEach((item) => {
    if (!item.percentage) {
      item.percentage = 100
    }
    if (!item.status) {
      item.status = 'success'
    }
  })
  fileList.value = val
}, { immediate: true })
// 监听taskStatus和taskId,判断删除按钮是否可以点击
watch(() => props.taskStatus, (val) => {
  deleteDisable.value = !!props.taskId && Number(val) === 0
}, { immediate: true })
watch(() => props.taskId, (val) => {
  deleteDisable.value = !!val && Number(props.taskStatus) === 0
}, { immediate: true })
// 支持的格式
const acceptArr = computed(() => {
  return props.accept.replace(/\s|\.*/g, '').split(',').filter((item) => item)
})
// 文件最大尺寸
const fileMaxSize = computed(() => {
  return formatSize(props.maxSize)
})
// 模版数组
const isMultiTemplate = computed(() => {
  if (Array.isArray(props.templateUrl) && props.templateUrl.length > 1) {
    return true
  } else {
    return false
  }
})


const emits = defineEmits(['onResetImport', 'input', 'onClose', 'toNextStep', 'onUploadSuccess', 'onResetImport', 'onUploadRemove'])
/** 换算文件最大大小展示名称 */
function formatSize(byte = props.maxSize, unitPos = 0) {
  if (byte < 1024 || unitPos >= unitsOfSize.length) {
    return Math.ceil(byte) + unitsOfSize[unitPos]
  } else {
    return formatSize(byte / 1024, ++unitPos)
  }
}

/** 文件变更钩子 上传成功/失败/变更均触发 */
function handleChange(file) {
  if (file.status !== 'ready') return
  loading.value = true
  emits('onResetImport')
  setTimeout(() => {
    /** NOTE：组件需求目前仅支持上传一个文件，所以超出限制/重新上传会覆盖文件列表 */
    if (fileList.value.length > 1) {
      fileList.value = []
      ref_uploader.value.clearFiles()
    }
    emits('input', fileList.value)
    loading.value = false
  }, timerGap)
}

/** 上传前钩子 */
function handleBeforeUpload(file) {
  // 文件类型校验
  const fileType = file.name.split('.').pop()
  const acceptValid = acceptArr.value.includes(fileType)

  if (!acceptValid) {
    Message({
      type: 'error',
      message: '支持格式不符合要求，请重新选择',
    })
    return false
  }

  // 文件大小校验
  const sizeValid = file.size < props.maxSize
  if (!sizeValid) {
    Message({
      type: 'error',
      message: '支持文件大小不符合要求，请重新选择',
    })
    return false
  }

  // 自定义校验
  let custom_flag = false
  if (props.onBeforeUpload && (typeof props.onBeforeUpload === 'function')) {
    custom_flag = props.onBeforeUpload(file)
  } else {
    custom_flag = true
  }
  if (!custom_flag) {
    return false
  }

  const fileObj = {
    uid: file.uid,
    name: file.name,
    lastModified: file.lastModified,
    size: file.size,
    type: file.type,
    status: 'uploading',
    percentage: 0,
    cancel: () => {},
  }
  fileList.value = [fileObj]
  return true
}

/** 删除文件钩子 */
function handleRemove(file) {
  loading.value = true
  emits('onResetImport')
  setTimeout(() => {
    const index = fileList.value.findIndex((item) => file.uid === item.uid)
    if (index >= 0) {
      const _f = JSON.parse(JSON.stringify(fileList.value[index]))
      fileList.value.splice(index, 1)
      ref_uploader.value.clearFiles()
      emits('onUploadRemove', _f)
    }
    emits('input', fileList.value)
    loading.value = false
  }, timerGap)
}

/** 带进度条上传 */
async function uploadRequest(req) {
  let res = null

  const param = {
    file: req.file,
    // 显示上传进度条
    handleProcess: (file) => {
      // upload,element-ui,自带的file-list显示进度条，如果 :show-file-list="true"，可使用下方注释方法
      // req.onProgress(file)
      const index = fileList.value.findIndex(
        (item) => req.file.uid === item.uid,
      )
      if (index >= 0) {
        fileList.value[index].percentage = Number(file.percent)
      }
    },
    // 取消上传方法
    handleCancel: (cb) => {
      const index = fileList.value.findIndex((item) => req.file.uid === item.uid)
      if (index >= 0) {
        fileList.value[index].cancel = cb
      }
    },
    group: props.group,
    code: props.code,
  }
  if (chunkSize && req.file.size / 1024 > chunkSize) {
    param.chunkSize = chunkSize
  }
  if (!props.shardUpload) {
    res = await uploadFileNotShared(param, props.uploadType)
  }
  // else if (props.privateMode) {
  //   res = await privateUploadWithPercent(param, props.uploadType)
  // } else {
  //   res = await publicUploadWithPercent(param, props.uploadType)
  // }
  // 请求执行完成后，处理数据
  const index = fileList.value.findIndex(
    (item) => req.file.uid === item.uid,
  )
  if (res && res.code === 1) {
    const { url, bucket, objectName } = res.data || {}
    fileList.value[index].url = url
    fileList.value[index].bucket = bucket
    fileList.value[index].objectName = objectName
    fileList.value[index].status = 'success'
  } else {
    fileList.value[index].status = 'fail'
  }
}

/** 上传成功钩子 */
function handleSuccess() {
  emits('onUploadSuccess', fileList.value)
  emits('input', fileList.value)
}

/** 上传失败钩子 */
function handleError() {
  emits('input', fileList.value)
}

/** 获取上传文件/列表 */
function getValue() {
  return fileList.value && fileList.value.length > 1 ? fileList.value : [...fileList.value]
}

/** 一步式导入 - 确定触发导入 */
function toNextStep() {
  emits('toNextStep', getValue())
}

/** 一步式导入 - 取消关闭弹框 */
function handleDialogClose() {
  emits('onClose', false)
}

/** 模版下载地址检查 */
function checkHref(href) {
  if (!href || href === '#') {
    Message({
      type: 'error',
      message: '下载失败，缺失模版下载地址',
    })
  }
}

/** 展示多模版下载弹框 */
function showTemplateDialog() {
  templateDialogVisible.value = true
}

function handleFilenameMouseOver(event) {
  tipShow.value = event.currentTarget.scrollWidth <= event.currentTarget.clientWidth
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  &.flex-col {
    flex-direction: column;
  }
  &.justify-between {
    justify-content: space-between;
  }
  &.justify-center {
    justify-content: center;
  }
  &.justify-around {
    justify-content: space-around;
  }
  &.justify-end {
    justify-content: flex-end;
  }
  &.align-center {
    align-items: center;
  }
}
.inline-block {
  display: inline-block;
}

.border-box {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 8px 24px 12px 12px;
  margin-top: 12px;
  max-width: 500px;
}

.twoCols {
  display: grid;
  grid-template-columns: 90px auto;
  align-items: baseline;
  padding: 0px 16px;
  height: 230px;
}

.history-slot-box, .template-box {
  margin-left: 12px;
}

.upload-file-content {
  .file-list-item {
    margin-bottom: 4px;
    .file-item-filename {
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 80%;
      overflow: hidden;
    }
    .icon-upload-success {
      margin-right: 5px;
      color: #2DA641;
    }
    .icon-upload-fail {
      margin-right: 5px;
      color: #D40000;
    }
  }
  .text-span {
    color: #303133;
    &.icon-left i {
      margin-right: 5px;
    }
    &.icon-right i {
      margin-left: 5px;
    }
  }

  .template-url-box {
    display: block;
    margin: 5px 0px;
  }
  .el-upload__tip {
    cursor: default;
    text-align: left;
  }
}
.dialog-footer {
  margin-top: 32px;
}
</style>
